import SearchResult from '../models/search_result.model';
import BaseNMComCollection from './base.nmcom.collection';
import SearchAdapter from '../adapters/search.adapter';

export default class SearchResults extends BaseNMComCollection {
	static model = SearchResult;
	static adapter = SearchAdapter;

	static transformResponseData(data = {}) {
		return data.documents || [];
	}

	promiseCreate(options = {}) {
		throw new Error('create is not allowed on search results');
	}

	promiseSave(options = {}) {
		throw new Error('save is not allowed on search results');
	}

	promiseDestroy(options = {}) {
		throw new Error('destroy is not allowed on search results');
	}
}
